import { render, staticRenderFns } from "./NewNotification.vue?vue&type=template&id=5805df8f&"
import script from "./NewNotification.vue?vue&type=script&lang=js&"
export * from "./NewNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports